/**
 * @file Disabled Link Extension for Tiptap
 *
 * This extension provides a way to disable link functionality while preserving
 * existing link content in the editor. It's designed for scenarios where you want to:
 *
 * - Prevent new users from creating links
 * - Handle existing content that contains links without breaking the app
 * - Show existing links as plain text instead of clickable links
 * - Allow gradual migration away from link functionality
 **/
import Link from '@tiptap/extension-link'

const DisabledLink = Link.configure({
  // Disable automatic linking
  autolink: false,
  // Disable paste-to-link functionality
  linkOnPaste: false,
  // Disable click to open links
  openOnClick: false,
  // Remove HTML attributes to make links render as plain text
  HTMLAttributes: {},
}).extend({
  // Override commands to make them no-ops
  addCommands() {
    return {
      setLink: () => () => false,
      toggleLink: () => () => false,
      unsetLink:
        () =>
        ({ chain }) => {
          // Allow unlinking existing links to convert them to text
          return chain().unsetMark(this.name).run()
        },
    }
  },

  // Override paste rules to prevent new links
  addPasteRules() {
    return []
  },

  // Override plugins to remove autolink behavior
  addProseMirrorPlugins() {
    return []
  },

  // Make links render as plain text for new content
  renderHTML({ HTMLAttributes }) {
    return ['span', {}, 0] // Render as span instead of <a>
  },
})

export { DisabledLink }
